<template>
  <span v-if="model.knockout" v-tooltip="knockoutReasons">
    <icon-base
      data-cy="icon-knockout"
      :icon="IconKnockout"
      :color="getKnockoutColor(model.knockout_details)"
    />
  </span>
</template>

<script setup lang="ts">
import { computed, inject } from "vue";

import { UTIL_COLORS } from "@/helpers/constants";
import { formatKnockoutReasons } from "@/helpers/scorecards";
import { ScorecardsIsViewKey } from "@/helpers/symbols";

import IconKnockout from "@/components/icons/IconKnockout.vue";

import type {
  ScorecardGroupCategoryForPreview,
  ScorecardResultsKnockout,
} from "@/models/scorecards";
import type { PropType } from "vue";

const props = defineProps({
  model: {
    type: Object as PropType<ScorecardGroupCategoryForPreview>,
    required: true,
  },
});

const pageIsView = inject(ScorecardsIsViewKey, true);

const getKnockoutColor = (knockout: ScorecardResultsKnockout | undefined) =>
  knockout ? UTIL_COLORS.WARNING : UTIL_COLORS.DEFAULT;

const knockoutReasons = computed<string | null>(() => {
  if (pageIsView) {
    return formatKnockoutReasons("", props.model.knockout_conditions, false);
  }
  if (props.model.knockout_details) {
    const conditions =
      props.model.knockout_details?.category?.knockout_conditions;
    if (!props.model.attribute) {
      return "";
    }
    return formatKnockoutReasons(props.model.attribute, conditions);
  }
  return null;
});
</script>
